require('./runtime');
"use strict";
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[3195],{

/***/ 62525:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _baUiCarbon = __webpack_require__(6536);
var _utils = __webpack_require__(78815);
var _reactDom = __webpack_require__(66405);
var _downshift = _interopRequireDefault(__webpack_require__(60772));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  BaPropTypes
} = _utils.propsUtils;

// determines if using the toolkit settings to allow input that does not match an item
const allowNonItemNumberValue = props => props.type === 'numeric';
const allowNonItemTextValue = props => props.type === 'text';
const allowNonItemValue = props => allowNonItemNumberValue(props) || allowNonItemTextValue(props);
const getLabel = (props, item) => {
  var _item$label;
  if (props.itemtoString) {
    return props.itemtoString(item);
  }
  if (typeof item === 'string') {
    return item;
  }
  return (_item$label = item == null ? void 0 : item.label) != null ? _item$label : '';
};

// return an items array based on props
const getItemsUsingProps = (props, selectedItem) => {
  var _ref;
  const {
    items,
    startingValues
  } = props;
  const list = (_ref = items != null ? items : startingValues) != null ? _ref : [];
  const listWithRef = allowNonItemValue(props) ? [{
    label: getLabel(props, selectedItem) || null
  }, ...list] : list;
  const listWithIds = listWithRef.map(item => ({
    id: getLabel(props, item),
    ...item
  }));
  return listWithIds;
};

// return an items array based on state
const getItemsUsingState = (props, state, selectedItem) => {
  const updatedItems = state.mappedItems;
  if (allowNonItemValue(props)) {
    updatedItems[0].label = getLabel(props, selectedItem) || null;
  }
  return updatedItems;
};

// finds and returns the selectedItem in the items list
// if not found return null
const getSelectedItem = (props, items, selectedItem) => {
  const labelToFind = getLabel(props, selectedItem).toLowerCase();
  if (!labelToFind) {
    return null;
  }
  const startingIndex = allowNonItemValue(props) ? 1 : 0;
  const foundItem = items.find((item, index) => index >= startingIndex && getLabel(props, item).toLowerCase() === labelToFind);
  if (foundItem) {
    return foundItem;
  }
  if (allowNonItemValue(props) && getLabel(props, items[0]).toLowerCase() === labelToFind) {
    return items[0];
  }
  return null;
};
class ComboBox extends _react.Component {
  constructor(props) {
    var _ref3;
    super(props);
    (0, _defineProperty2.default)(this, "isCarbonated", this.props.type && !allowNonItemValue(this.props));
    (0, _defineProperty2.default)(this, "mappedShouldFilterItem", shouldFilterItemObj => {
      var _getLabel$toLowerCase, _getLabel;
      const {
        disableFilter,
        shouldFilterItem // eslint-disable-line react/prop-types
      } = this.props;
      const {
        inputValue,
        item
      } = shouldFilterItemObj;
      if (allowNonItemValue(this.props) && item === this.state.mappedItems[0]) {
        // always hide the type in reference item
        return false;
      }
      if (disableFilter) {
        // toolkit supplied prop to not filter
        return true;
      }
      if (shouldFilterItem) {
        // Carbon supplied prop for client supplied filter condition
        return shouldFilterItem(shouldFilterItemObj);
      }

      // default: toolkit filters case insensitive and starts with
      return (_getLabel$toLowerCase = (_getLabel = getLabel(this.props, item)) == null ? void 0 : _getLabel.toLowerCase().startsWith(inputValue == null ? void 0 : inputValue.toLowerCase())) != null ? _getLabel$toLowerCase : true;
    });
    (0, _defineProperty2.default)(this, "mappedOnChange", onChangeObject => {
      var _this$props$onChange, _this$props;
      // toolkit changed the payload for onChange to be a selectedItem object
      // map the onChange payload to be the Carbon payload or the old toolkit payload
      // eslint-disable-next-line react/prop-types
      (_this$props$onChange = (_this$props = this.props).onChange) == null ? void 0 : _this$props$onChange.call(_this$props, this.isCarbonated ? onChangeObject : onChangeObject.selectedItem || {});
    });
    (0, _defineProperty2.default)(this, "mappedOnInputChange", onInputChangeObject => {
      var _this$props$onInputCh, _this$props2, _this$props$onTextCha, _this$props3;
      // if carbon onInputChange pass back anything
      (_this$props$onInputCh = (_this$props2 = this.props).onInputChange) == null ? void 0 : _this$props$onInputCh.call(_this$props2, onInputChangeObject); // eslint-disable-line react/prop-types
      (_this$props$onTextCha = (_this$props3 = this.props).onTextChange) == null ? void 0 : _this$props$onTextCha.call(_this$props3, onInputChangeObject);
    });
    (0, _defineProperty2.default)(this, "checkInput", () => {
      // non-item numeric entries are allowed
      // and the selectedItem is a type in value
      if (allowNonItemNumberValue(this.props) && this.state.mappedSelectedItem === this.state.mappedItems[0]) {
        // the scale check is not needed: only format has
        // type=numeric and all format numerics are integers.
        const {
          min,
          max /* , scale */
        } = this.props;
        const {
          label
        } = this.state.mappedItems[0];
        const valueInt = parseInt(label); // eslint-disable-line radix
        const valueNumber = Number(label);
        if (valueInt === valueNumber && (min === undefined || valueInt > Number(min)) && (max === undefined || valueInt < Number(max))) {
          // either, no change required or need to clean value
          return String(valueInt) === label ? undefined : String(valueInt);
        }

        // need to clear
        return null;
      }

      // no change required
      return undefined;
    });
    (0, _defineProperty2.default)(this, "handleStateReducer", (state, changes) => {
      // this is the only state change I could find to handle mouse click
      // Carbon overloads blurInput, keyDownEnter, and onOuterClick
      if (changes.type === _downshift.default.stateChangeTypes.mouseUp) {
        const checkedInput = this.checkInput();
        if (checkedInput !== undefined) {
          // change required; either clear or clean the data
          return {
            ...changes,
            inputValue: checkedInput
          };
        }
      }

      // no change required
      return changes;
    });
    (0, _defineProperty2.default)(this, "handleKeyUp", _ref2 => {
      let {
        keyCode
      } = _ref2;
      // check if the key pressed was ENTER
      if (keyCode === 13) {
        const checkedInput = this.checkInput();
        if (checkedInput !== undefined) {
          // change required; either clear or clean the data
          this.mappedOnInputChange(checkedInput);
        }
      }
    });
    (0, _defineProperty2.default)(this, "handleRef", node => {
      if (node) {
        const {
          customWidth
        } = this.props;
        const domNode = (0, _reactDom.findDOMNode)(node);

        // set the width of the ComboBox node
        domNode.style.setProperty('width', customWidth != null ? customWidth : '100%');
        if (allowNonItemValue(this.props)) {
          // find the input tag in the ComboBox node
          const inputTag = domNode.querySelector('input');
          inputTag.addEventListener == null ? void 0 : inputTag.addEventListener('keyup', this.handleKeyUp);
        }
      }
    });
    const {
      selectedItem,
      // eslint-disable-line react/prop-types
      selectedValue,
      initialSelectedItem // eslint-disable-line react/prop-types
    } = props;
    const _item = (_ref3 = selectedItem != null ? selectedItem : selectedValue) != null ? _ref3 : initialSelectedItem;
    const mappedItems = getItemsUsingProps(props, _item);
    const mappedSelectedItem = getSelectedItem(props, mappedItems, _item);
    this.state = {
      mappedItems,
      mappedSelectedItem
    };
  }
  static getDerivedStateFromProps(props, state) {
    var _state$mappedItems$;
    const refLabel = (_state$mappedItems$ = state.mappedItems[0]) == null ? void 0 : _state$mappedItems$.label;
    const propMappedItems = getItemsUsingProps(props, refLabel);
    const stateMappedItems = getItemsUsingState(props, state, refLabel);
    if (JSON.stringify(propMappedItems) !== JSON.stringify(stateMappedItems)) {
      return {
        mappedItems: propMappedItems,
        mappedSelectedItem: getSelectedItem(props, propMappedItems, state.mappedSelectedItem)
      };
    }
    return null;
  }
  componentDidUpdate(prevProps) {
    const {
      selectedItem: currSelectedItem,
      // eslint-disable-line react/prop-types
      selectedValue: currSelectedValue
    } = this.props;
    const {
      selectedItem: prevSelectedItem,
      // eslint-disable-line react/prop-types
      selectedValue: prevSelectedValue
    } = prevProps;
    const currItem = currSelectedItem != null ? currSelectedItem : currSelectedValue;
    const prevItem = prevSelectedItem != null ? prevSelectedItem : prevSelectedValue;
    const currLabel = currItem ? getLabel(this.props, currItem) : undefined;
    const prevLabel = prevItem ? getLabel(this.props, prevItem) : undefined;
    if (currLabel !== prevLabel) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(state => {
        const stateMappedItems = getItemsUsingState(this.props, state, currItem);
        return {
          mappedItems: stateMappedItems,
          mappedSelectedItem: getSelectedItem(this.props, stateMappedItems, currItem)
        };
      });
    }
  }

  // determines if ComboBox props are to behave as Carbon props (type set to a non-toolkit option)

  // filter the items in the list to show in the drop down

  // onChange is a utility for this controlled component to communicate
  // to a consuming component when a specific dropdown item is selected.
  // Callback function to notify consumer when the text input changes.
  // This provides support to change available items based on the text.
  // check the typed in value
  // if a typed in value, and it is invalid, clear it = null
  // if a typed in value, and it needs cleaning = return the cleaned value
  // in all other cases no change is required = undefined
  render() {
    var _this$state$mappedSel, _this$state$mappedSel2;
    const {
      // removed - remapped
      /* eslint-disable react/prop-types */
      ariaLabel,
      invalid,
      invalidText,
      items,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onChange,
      onInputChange,
      selectedItem,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      shouldFilterItem,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      /* eslint-enable react/prop-types */
      size,
      type,
      // removed - deprecated
      ariaLabelOfDropdown,
      customWidth,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      disableFilter,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      dropdownFooterRenderer,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      dropdownHeaderRenderer,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      grouped,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      hasValidationError,
      inputIconLeft,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      isAttachedToDomNode,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      numberInputExtraOptions,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onTextChange,
      selectedValue,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      startingValues,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      textInputExtraOptions,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      validationErrorText,
      // pass all other props to CarbonComboBox
      ...otherCarbonComboBoxProps
    } = this.props;
    const mappedAriaLabel = ariaLabel != null ? ariaLabel : ariaLabelOfDropdown;
    const mappedInvalid = invalid != null ? invalid : hasValidationError;
    const mappedInvalidText = invalidText != null ? invalidText : validationErrorText;
    const mappedOnChange = onChange || allowNonItemValue(this.props) ? this.mappedOnChange : undefined;
    const mappedOnInputChange = onInputChange || onTextChange || allowNonItemValue(this.props) ? this.mappedOnInputChange : undefined;
    const mappedSize = size === 'small' ? 'sm' : size === 'large' ? 'lg' : size === 'normal' ? undefined : size;
    const mappedType = allowNonItemValue(this.props) ? undefined : type;
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.ComboBox, (0, _extends2.default)({
      "data-tid": "ba-common-combobox__list-dropdown",
      ref: this.handleRef
    }, otherCarbonComboBoxProps, {
      ariaLabel: mappedAriaLabel,
      invalid: mappedInvalid,
      invalidText: mappedInvalidText,
      items: this.state.mappedItems
      // onChange is a utility for this controlled component to communicate to a
      // consuming component when a specific dropdown item is selected.
      ,
      onChange: mappedOnChange
      // Callback function to notify consumer when the text input changes.
      // This provides support to change available items based on the text.
      ,
      onInputChange: mappedOnInputChange,
      selectedItem: (_this$state$mappedSel = (_this$state$mappedSel2 = this.state.mappedSelectedItem) == null ? void 0 : _this$state$mappedSel2.label) != null ? _this$state$mappedSel : null,
      shouldFilterItem: this.mappedShouldFilterItem,
      size: mappedSize,
      type: mappedType,
      downshiftProps: {
        stateReducer: this.handleStateReducer
      }
    }));
  }
}
exports["default"] = ComboBox;
(0, _defineProperty2.default)(ComboBox, "propTypes", {
  /** Size in carbon is 'sm', 'lg', or 'xl', the toolkit 'small', 'normal', and 'large' are deprecated */
  size: _propTypes.default.oneOf(['large', 'lg', 'normal', 'sm', 'small', 'xl']),
  /** type in carbon is 'default' or 'variant', the toolkit 'text' or 'numeric' options are deprecated */
  // ComboBox'es by default only allow values that match an item in the items list.
  // The toolkit types (numeric or text) indicates the ComboBox value does not have to match an item in the items.
  // ie: if types is (numeric or text) the user can type in a value and it does not have to match an item in the items.
  type: _propTypes.default.oneOf(['default', 'numeric', 'text', 'variant']).isRequired,
  /** deprecated - not supported in Carbon */
  allowEmpty: BaPropTypes.deprecated(' is ignored and not applicable to carbon combobox'),
  /** deprecated - use ariaLabel */
  ariaLabelOfDropdown: BaPropTypes.deprecated('deprecated - use ariaLabel'),
  /** deprecated - not supported in Carbon */
  customWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** deprecated - use shouldFilterItem */
  disableFilter: BaPropTypes.deprecated('deprecated - use shouldFilterItem'),
  /** deprecated - not supported in Carbon */
  dropdownFooterRenderer: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - not supported in Carbon */
  dropdownHeaderRenderer: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - not supported in Carbon */
  grouped: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - use invalid */
  hasValidationError: BaPropTypes.deprecated('deprecated - use invalid'),
  /** deprecated - not supported in Carbon */
  inputIconLeft: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - not supported in Carbon */
  isAttachedToDomNode: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - not supported in Carbon */
  max: BaPropTypes.deprecated(' is ignored and not applicable to carbon combobox'),
  /** deprecated - not supported in Carbon */
  min: BaPropTypes.deprecated(' is ignored and not applicable to carbon combobox'),
  /** deprecated - not supported in Carbon */
  numberInputExtraOptions: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - use onInputChange */
  onTextChange: BaPropTypes.deprecated('deprecated - use onInputChange'),
  /** deprecated - not supported in Carbon */
  scale: BaPropTypes.deprecated(' is ignored and not applicable to carbon combobox'),
  /** deprecated - use selectedItem */
  selectedValue: BaPropTypes.deprecated('deprecated - use selectedItem'),
  /** deprecated - use items */
  startingValues: BaPropTypes.deprecated('deprecated - use items'),
  /** deprecated - not supported in Carbon */
  textInputExtraOptions: BaPropTypes.deprecated('deprecated - not supported in Carbon'),
  /** deprecated - use invalidText */
  validationErrorText: BaPropTypes.deprecated('deprecated - use invalidText')
});
(0, _defineProperty2.default)(ComboBox, "__ComboBox__", true);

/***/ }),

/***/ 99013:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _ComboBox = _interopRequireDefault(__webpack_require__(62525));
exports["default"] = _ComboBox.default;
exports.ComboBox = _ComboBox.default;

/***/ }),

/***/ 6536:
/***/ ((module) => {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 60772:
/***/ ((module) => {

module.exports = require("downshift");

/***/ }),

/***/ 580:
/***/ ((module) => {

module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ 66405:
/***/ ((module) => {

module.exports = require("react-dom");

/***/ }),

/***/ 78815:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(99013));
/******/ return __webpack_exports__;
/******/ }
]);
});